import { basicInitialState } from '../_utils/basicInitialState';
import { TUserGroupEditorState } from './userGroupEditorModel';

export const userGroupEditorInitialState: TUserGroupEditorState = {
  ...basicInitialState,
  group: null
};
